import { useEffect, useRef } from 'react';
export function useClickOutside(handler, enabled = true) {
    const ref = useRef(null);
    useEffect(() => {
        if (!enabled)
            return;
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handler, enabled]);
    return ref;
}
